// extracted by mini-css-extract-plugin
export default {"scope":"tYzvY","icon":"W4guK"};